import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { CommunicationService } from '../../services/communication/communication.service';
import { first } from 'rxjs/operators'

/**
 * This guard is used to fetch all the templates before loading the other component
 */

@Injectable()
export class DynamicBoardsGuard implements CanActivate {
  constructor(private communicationService: CommunicationService) {}

  async canActivate(): Promise<boolean> {
    return new Promise(resolve => {
      this.communicationService.getBoards.pipe(first()).subscribe(routeList=>{
        if(!routeList.length)
          this.communicationService.getBoard().then(res=>{
            resolve(true);
          })
        else
          resolve(true);
      })
      this.communicationService.getAllTemplates();
    })
  }
}